import React from 'react';
import { Button } from '@heycater/design-system';
import { useTranslation } from 'react-i18next';

import { marketplaceURL } from 'shared/helpers/urls';

function FindVirtualEventsButton(props) {
  const { t } = useTranslation('static_pages');

  return (
    <Button
      size="md"
      as="a"
      href={marketplaceURL('/catering/virtual_events')}
      {...props}
    >
      {t('common:labels.findVirtualEvents')}
    </Button>
  );
}

export default FindVirtualEventsButton;
